module.exports = "<div class=block-title>LABELS</div> <dt-labels-autocomplete labels=$ctrl.labels require-match=false editable=true placeholder=\"Start typing to add a label\" secondary-placeholder=\"Add more labels\" on-add=$ctrl.onLabelsAdded($event) on-remove=$ctrl.onLabelsRemoved($event)></dt-labels-autocomplete>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-labels/thing-details-labels.html
// module id = laKs
// module chunks = 1